import { useDreamSearchFilterContext } from "@portal/app/health/_components/components/filter/DreamSearchFilterContext";
import { faHandHeart } from "@fortawesome/pro-duotone-svg-icons/faHandHeart";
import { useState } from "react";
import { useDreamSearchContext } from "@portal/app/health/_components/DreamSearchContext";
import { FilterPill } from "./OnlineClassesFilterPill";
import { useMixpanel } from "@portal/app/_components/hooks/useMixpanel";

export const FinancialAidFilterPill = () => {
  const analytics = useMixpanel();
  const { filterSettings } = useDreamSearchContext();
  const { filters, setFilters } = useDreamSearchFilterContext();
  const [isActive, setIsActive] = useState(
    !!filters["program_payment_options_type_in"]?.includes("SCHOOL_FINANCIAL_AID")
  );

  return filterSettings?.paymentOptionType.includes("SCHOOL_FINANCIAL_AID") ? (
    <FilterPill
      onClick={() => {
        setIsActive(!isActive);
        if (!isActive) {
          void analytics.track("Dream Search - Filter", {
            featured: "Financial aid",
            filterGroup: "program_payment_options_type_in",
            filterItem: "SCHOOL_FINANCIAL_AID",
            filters,
          });
        }
        return setFilters(({ program_payment_options_type_in, ...prevFilters }) => ({
          ...prevFilters,
          program_payment_options_type_in: isActive ? [] : ["SCHOOL_FINANCIAL_AID"],
        }));
      }}
      isActive={isActive}
      title="Financial aid"
      iconProps={{
        icon: faHandHeart,
        color: isActive ? "#04299E" : "#04299E70",
      }}
      data-testid="dream-search-filter-financial-aid"
    />
  ) : null;
};
